import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import tw from 'tailwind.macro';
import AppLink from '../../../../components/AppLink';
import { arrowLinkStyle } from '../../../../components/ArrowLink';
import { H3 } from '../../../../components/Typographies/Title';
import { topTravels } from '../../../../data/travelList';
import { homePageTravelListMessages } from './messages';
import TravelListItem from './TravelListItem';

const Container = styled.div`
  ${tw`mt-big flex flex-col mx-auto`}
  gap:var(--size-huge);
  max-width: 1040px;
`;

const Title = styled(H3)`
  ${tw`text-center`}
`;

const Grid = styled.div`
  ${tw`flex flex-wrap justify-start`};
`;

const TravelList = () => (
  <Container>
    <Title>
      <FormattedMessage {...homePageTravelListMessages.travelListTitle} />
    </Title>
    <Grid>
      {topTravels.map((travel) => (
        <AppLink
          key={travel.id}
          content={<TravelListItem travel={travel} />}
          mustReload
          styles={[arrowLinkStyle]}
          url={travel.url}
        />
      ))}
    </Grid>
  </Container>
);

export default TravelList;
